import { Link } from 'react-router-dom';
import { styled } from "@mui/material/styles";

const RouterLink = styled(Link)(({theme}) => ({
    color: theme.palette.text.primary,
    transition: '0.1s',
}));

export default RouterLink;
